import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'step-process-buttons',
  templateUrl: './step-process-buttons.component.html'
})
export class StepProcessButtonsComponent {
  @Input() stepper: MatStepper;
  @Input() submissionStepIndex = -1;
  @Input() nextText = "Next";
  @Input() submitText = "Submit";

  @Output() backEvent: EventEmitter<boolean> = new EventEmitter();
  @Output() nextEvent: EventEmitter<boolean> = new EventEmitter();
  @Output() submitEvent: EventEmitter<boolean> = new EventEmitter();

  public faChevronLeft = faChevronLeft;
  public faChevronRight = faChevronRight;

  public backClicked(): void {
    this.backEvent.emit();
  }

  public nextClicked(): void {
    this.nextEvent.emit();
  }
  
  public submitClicked(): void {
    this.submitEvent.emit();
  }

  public isFirstStep(): boolean {
    return this.stepper?.selectedIndex === 0;
  }

  public isSubmissionStep(): boolean {
    return (this.submissionStepIndex === -1) ?
      this.stepper?.selectedIndex === this.stepper?.steps?.length - 1 :
      this.stepper?.selectedIndex === this.stepper?.steps?.length - 1 || this.stepper?.selectedIndex === this.submissionStepIndex
  }

  public isLastStep(): boolean {
    return this.stepper?.selectedIndex === this.stepper?.steps?.length - 1;
  }

  public shouldShowBackButton(): boolean {
    return !this.isFirstStep() ;
  }
}